
















import { defineComponent, ref, computed, onMounted, onUnmounted, ComponentInstance } from '@vue/composition-api';
import { ValueOf } from 'type-fest';
import { Component } from 'vue';

const className = 'AlertModal';

export const MODAL_STATE = {
  LOADING: -1,
  IDLE: 0,
  APPLY: 1,
} as const;

export type ModalState = ValueOf<typeof MODAL_STATE>;

export type ShowModalOption = {
  ApplyButtonComponent: Component;
  CancelButtonComponent: Component;
  MessageComponent: Component;
};

export default defineComponent({
  name: 'AlertModal',

  setup() {
    const self = ref<ComponentInstance>();
    const components = ref<ShowModalOption>();
    const state = ref<ModalState>(MODAL_STATE.IDLE);
    // const modalMessage = ref<ModalMessage>(MODAL_MESSAGE_PRESETS.alert);
    /**
     * v-dialogの状態とバインドする。
     */
    const value = computed({
      get: () => state.value !== MODAL_STATE.IDLE,
      set: (v: boolean) => {
        // このsetterはモーダル外がクリックされて閉じる処理が発生するときに実行される。
        state.value = v ? MODAL_STATE.LOADING : MODAL_STATE.IDLE;
      },
    });
    /**
     * モーダル表示を行う。外部からref参照して叩く。
     */
    const show = (options: ShowModalOption) => {
      state.value = MODAL_STATE.LOADING;
      components.value = options;
    };
    /**
     * モーダルを閉じる。ボタンに仕掛けるイベントハンドラだが、外部からモーダル閉じるときも使用する。
     */
    const hide = () => {
      state.value = MODAL_STATE.IDLE;
    };
    /**
     * 処理を承認する。ボタンに仕掛けるイベントハンドラ。
     */
    const apply = () => {
      state.value = MODAL_STATE.APPLY;
    };

    // modalの表示状態を監視し、dom描画を制御する。
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach(({ target }) => {
        if (target instanceof HTMLElement && target.style.display === 'none') {
          // 見えなくなったらdomも消す。
          components.value = undefined;
        }
      });
    });
    observer.disconnect();
    onMounted(() => {
      const dialogContainer = self.value?.$refs.dialog;
      if (dialogContainer instanceof HTMLElement) {
        observer.observe(dialogContainer, {
          attributeFilter: ['style'],
          attributes: true,
          subtree: false,
          childList: false,
        });
      }
    });
    onUnmounted(() => {
      observer.disconnect();
    });

    return {
      self,
      components,
      className,
      value,
      state,
      show,
      hide,
      apply,
      containerClassName: 'AlertModal__Container',
    };
  },
});
